import { SessionTransport } from './SessionTransport';

/**
 * 전역 sticky 세션 제어 바(#21, #25, #27).
 *
 * 콘솔이 탭으로 나뉘고 길어도, 어느 탭에서든 스크롤 위치와 무관하게 모든 transport
 * 제어(시작/정지/일시정지/재개)에 닿게 화면 하단에 항상 고정한다. 제어 본체는
 * 단일 `SessionTransport`가 소유한다(정지 버튼은 항상 1개).
 */
export const SessionStickyBar = () => <SessionTransport />;
